import { APP_COLORS } from "../enums";

const customMuiCheckbox: any = {
  styleOverrides: {
    root: {
      "& svg": {
        fontSize: 24,
      },
      color: APP_COLORS.primary,
      "&.Mui-checked": {
        color: APP_COLORS.primary,
      },
      "&.MuiCheckbox-indeterminate": {
        color: APP_COLORS.primary,
      },
    },
  },
};

export { customMuiCheckbox };
